import { render, staticRenderFns } from "./modal-new-prospect-prompt.vue?vue&type=template&id=53ef2fb0"
import script from "./modal-new-prospect-prompt.vue?vue&type=script&lang=js"
export * from "./modal-new-prospect-prompt.vue?vue&type=script&lang=js"
import style0 from "./modal-new-prospect-prompt.vue?vue&type=style&index=0&id=53ef2fb0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports